<template>
  <sui-page>
    <sui-page-header title="현황 조회" />
    <sui-page-contents>
      <div class="comm_title_wrap">
        <!-- 기본정보 -->
        <h4>{{ $t('MSG_TIT_DEFAULT_INFO') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <!-- 제목 -->
            <sui-input-label :label="$t('MSG_TIT_TTL')" />
          </div>
          <div class="col-xs-11">
            <div class="comm_label">
              {{ approvalTitle }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <!-- 작성자 -->
            <sui-input-label :label="$t('MSG_TIT_DOC_CRTR')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ drafterSummary }}
            </div>
          </div>
          <div class="col-xs-1">
            <!-- 결재상태 -->
            <sui-input-label :label="$t('MSG_TIT_APRV_STT')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ approvalProgressStateCodeName }}
            </div>
          </div>
        </div>
      </div>
      <div class="comm_title_wrap">
        <!-- 결재 정보 -->
        <h4>{{ $t('MSG_TIT_APRV_INFO') }}</h4>
      </div>
      <div class="comm_scroll_TB">
        <div class="comm_ListTB">
          <table
            width="100%"
            border="0"
            cellspacing="0"
            cellpadding="0"
          >
            <colgroup>
              <col width="60px">
              <col width="100px">
              <col width="*">
              <col width="150px">
              <col width="150px">
              <col width="150px">
              <col width="180px">
              <col width="80px">
              <col width="80px">
            </colgroup>
            <tr>
              <th>
                <!-- 순번 -->
                <div>{{ $t('MSG_TXT_SN') }}</div>
              </th>
              <th>
                <!-- 상태 -->
                <div>{{ $t('MSG_TXT_STT') }}</div>
              </th>
              <th>
                <!-- 이름 -->
                <div>{{ $t('MSG_TXT_NAME') }}</div>
              </th>
              <th>
                <!-- 도착일시 -->
                <div>{{ $t('MSG_TIT_ARVL_DTM') }}</div>
              </th>
              <th>
                <!-- 개봉일시 -->
                <div>{{ $t('MSG_TXT_OPEN_DTM') }}</div>
              </th>
              <th>
                <!-- 처리일시 -->
                <div>{{ $t('MSG_TIT_PROC_DTM') }}</div>
              </th>
              <th>
                <!-- 부서명 -->
                <div>{{ $t('MSG_TXT_DEPT_NM') }}</div>
              </th>
              <th>
                <!-- 경로변경 -->
                <div>{{ $t('MSG_TIT_APRV_LINE_CHG') }}</div>
              </th>
              <th>
                <!-- 본문변경 -->
                <div>{{ $t('MSG_TIT_TBAB_CHG') }}</div>
              </th>
            </tr>
            <template
              v-for="(user,index) in approvalUserList"
            >
              <tr
                :key="index"
              >
                <td
                  :rowspan="isUserOpinionExist(user.approvalOpinionContent) ? 2: 1"
                >
                  {{ user.approvalParallelOrder }}
                </td>
                <td
                  :rowspan="isUserOpinionExist(user.approvalOpinionContent) ? 2: 1"
                >
                  {{ user.rightApprovalTypeStateCodeName }}
                </td>
                <td>{{ `${getDisplayText(user.userDisplayLanguageId, user.approvalUserName, user.approvalUserGlobalName)}(${user.approvalUserEmail.replace(/@.*/,'')})` }}</td>
                <td>{{ user.arrivalDTM | dateformatToClient }}</td>
                <td>{{ user.approvalUnsealDTM | dateformatToClient }}</td>
                <td>{{ user.approvalDTM | dateformatToClient }}</td>
                <td>{{ getDisplayText(user.userDisplayLanguageId, user.approvalDepartmentName, user.approvalDepartmentEnglishName) }}</td>
                <td
                  class="ta_c"
                >
                  <sui-button
                    v-if="user.approvalLineChangeYn == 'Y'"
                    type="button"
                    class="btn_check"
                    @click="onClickViewLineChanged(user.approvalUid, user.approvalOrder)"
                  />
                  <template
                    v-else
                  >
                    -
                  </template>
                </td>
                <td
                  class="ta_c"
                >
                  <sui-button
                    v-if="user.approvalContentChangeYn == 'Y'"
                    type="button"
                    class="btn_check"
                    @click="onClickViewContentChanged(user.approvalUid, user.approvalOrder)"
                  />
                  <template
                    v-else
                  >
                    -
                  </template>
                </td>
              </tr>
              <tr
                v-if="isUserOpinionExist(user.approvalOpinionContent)"
                :key="`10000${index}`"
              >
                <td colspan="7">
                  {{ user.approvalOpinionContent }}
                </td>
              </tr>
            </template>
          </table>
        </div>
      </div>

      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onClickConfirm"
        >
          {{ $t('MSG_BTN_CFRM') }}
        </sui-button>
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CML_00013', // eslint-disable-line vue/name-property-casing
  filters: {
    /**
     * 
     */
    dateformatToClient(value) {
      const result = utils.dateformatToClient(value);
      return utils.isDate(result) ? result : '-';
    },
  },
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default: null,
    },
    pageInitialData: {
      type: Object,
      required: false,
      default() {
        return {
          approvalUid: '',
        };
      },
    },
  },
  data() {
    return {
      approvalTitle: '',
      approvalDraftDTM: '', // 작성일시
      drafterSummary: '',
      approvalProgressStateCode: '', // 결재진행상태코드
      approvalProgressStateCodeName: '',
      //
      approvalUserList: [],
    };
  },
  computed: {},
  watch: {},
  datasets: [],
  mounted() {
    if (utils.trim(this.pageInitialData.approvalUid) === '') {
      // 'approvalUid 가 존재하지 않습니다.'
      utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), utils.strFormat(this.$t('MSG_ALT_IT_NOT_EXIST'), 'approvalId'));
    } else {
      this.loadData();
    }
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    confirmProposalCancel() {
      return new Promise(resolve => {
        // "상신 취소하시겠습니까?"
        utils.messageBox('confirm', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_PRGS_APRV_CNCL'), () => {
          resolve(true);
        }, () => {
          resolve(false);
        });
      });
    },
    /**
     * 세션 langId 와 displayLangId 를 비교하여 두 개의 값중 하나를 return
     */
    getDisplayText(displayLangId = '', localTextValue = '', globalTextValue = '') {
      return this.$store.getters.userInfo.langId === displayLangId ? localTextValue : globalTextValue;
    },
    /**
     * 상신의견 값이 존재하는지 확인하여 true/false 반환
     * check existence of approval opinion text and return true/false
     */
    isUserOpinionExist(opinion = '') {
      return utils.trim(opinion) !== '';
    },
    /**
     * approvalUid 에 해당하는 결재 상세 데이터 조회
     */
    loadData() {
      http.request(this.contextPageId, 'DTS_CML_00009', {
        path: {
          'approval-uid': this.pageInitialData.approvalUid,
        },
      }).then(res => {
        this.approvalTitle = res.data.approvalTitle;
        // 작성자
        const drafter = utils.find(res.data.approvalUserList, { approvalOrder: 0 });
        this.drafterSummary = `${this.getDisplayText(drafter.userDisplayLanguageId, drafter.approvalUserName, drafter.approvalUserGlobalName)}(${drafter.approvalUserEmail.replace(/@.+/, '')}) / ${this.getDisplayText(drafter.userDisplayLanguageId, drafter.approvalDepartmentName, drafter.approvalDepartmentEnglishName)}`;
        this.approvalUserList = res.data.approvalUserList;
        this.approvalDraftDTM = utils.dateformatToClient(res.data.approvalDraftDTM);
        this.approvalProgressStateCode = res.data.approvalProgressStateCode;
        this.approvalProgressStateCodeName = res.data.approvalProgressStateCodeName;
        let isAfterRejectOrReturn = false;
        utils.forEach(this.approvalUserList, user => {
          if (utils.last(user.rightApprovalTypeStateCode) === '2') {
            isAfterRejectOrReturn = true;
          } else if (isAfterRejectOrReturn) {
            user.arrivalDTM = '-';
          }
        });
      });
    },
    /**
     * '확인' 버튼 click event handler
     */
    onClickConfirm() {
      this.closePagePopup('');
    },
    /**
     * 이전 결재내용 조회 팝업
     */
    onClickViewContentChanged(approvalUid, approvalOrder) {
      utils.openLayerPopup('PGE_CML_00015', null, {
        pageInitialData: {
          approvalUid,
          approvalOrder,
        },
        size: 'xlg',
      });
    },
    /**
     * 이전 결재선 조회 팝업
     */
    onClickViewLineChanged(approvalUid, approvalOrder) {
      utils.openLayerPopup('PGE_CML_00014', null, {
        pageInitialData: {
          approvalUid,
          approvalOrder,
        },
        size: 'xlg',
      });
    },
  },
};
</script>
<style scoped>
</style>
